import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classnames from "classnames";

import { Notification } from "components/alerts/Notification";
import Styles from "components/alerts/Notification.module.scss";
import { Portal } from "components/general/Portal";
import { UiActions } from "state/actions/UiActions";
import { NotifsActions } from "state/actions/user/NotifsActions";
import { Glambox } from "components/icons/Glambox";

class Notifications extends Component {
  _renderNotifs = () => {
    let { notifs } = this.props;
    
    if (!notifs || notifs.length === 0) return (
      <span className={Styles["no-notifications"]}>Não existem notificações!</span>
      );
    
    return notifs.map((item, key) => {
      return (
        <Notification notification={item} key={key}/>
      );
    });
  };
  
  dismissNotification = (id) => {
    return () => {
      this.props.readNotif(id);
    }
  };
  
  render () {
    const { visible } = this.props.ui.notifs;
    
    let _cls = [Styles["gb-notifs"]],
        _clsList = [Styles["gb-notifs__list"]];
    if (visible === true) {
      _cls.push(Styles["visible"]);
      _clsList.push(Styles["visible"]);
    }
    
    return (
      <Portal id={"gb-notifs"}>
        <div className={classnames(_cls)}>
          <div className={classnames(_clsList)}>
            <section>
              Notificações atuais <button onClick={this.props.closeNotifs}>x</button>
            </section>
            {this._renderNotifs()}
          </div>
          <div className={Styles["gb-notifs__backdrop"]} onClick={this.props.closeNotifs}></div>
        </div>
      </Portal>
    );
  }
}

Notifications.defaultProps = {};

Notifications.propTypes = {};

const mapStateToProps = (state) => ({
  ui: state.ui,
  notifs: state.notifs.data,
  token: state.token.data
});

const mapDispatchToProps = (dispatch) => ({
  readNotif: (notificationId) => {
    dispatch(NotifsActions.dismiss(notificationId));
  },
  closeNotifs: () => {
    dispatch(UiActions.notifsHide())
  }
});

Notifications = connect(mapStateToProps, mapDispatchToProps)(Notifications);

export {
  Notifications
};
